(function() {

  zfrespond.views.QuestionsHeaderView = Backbone.View.extend({

    className: 'questions-header-view',
    
    events: {
      'click .action-back-to-welcome': 'handleBackToWelcome',
      'click .action-finish': 'handleFinish'
    },

    template: ZFRESPOND_JST['respond.questions_header'],

    initialize: function(options) {
      this.allResponses = options.allResponses;
      this.fields = options.fields;

      if (options.fixed) {
        this.$el.addClass('fixed');
      }

      this.listenTo(this.allResponses, 'add remove reset', 
                                _.debounce(this.renderCountResponses, 5));
    },

    isFixed: function() {
      return this.$el.hasClass('fixed');
    },

    render: function() {
      this.$el.html(this.template({ totalCount: this.fields.length }));
      this.renderCountResponses();
      return this;
    },

    renderCountResponses: function() {
      var questionsCompleted = _.size(this.allResponses.groupBy('collector_field_id'));

      if (this.allResponses.length) {
        this.$('.im-finished-button').removeClass('disabled');
      }
      this.$('.completed-count').text(questionsCompleted);
      this.$('.questions-completed-text').text(
        'question' + (questionsCompleted != 1 ? 's' : '') + ' completed'
      );
    },
    
    handleBackToWelcome: function(){
      this.trigger('goto:welcome');
    },
    
    handleFinish: function(e) {
      if ($(e.currentTarget).hasClass('disabled')) {
        return;
      }
      zfrespond.views.CompletedModalView.show(this.model);
    }

  });

}());
